import { combineReducers } from 'redux';
import { FAILED_GET_PEP_ROLES, FAILED_GET_RCA_ROLES, FETCHING_PEP_ROLES, FETCHING_RCA_ROLES, GET_PEP_ROLE_COUNTRIES, GET_PEP_ROLES, GET_RCA_ROLES, PEP_RCA_SAVE_ERROR, SUBMITTED_PEP_RCA } from '../actions/pepRca';
export let FetchingState = /*#__PURE__*/function (FetchingState) {
  FetchingState["INITIAL"] = "initial";
  FetchingState["LOADING"] = "loading";
  FetchingState["LOADED"] = "loaded";
  FetchingState["FAILED"] = "failed";
  return FetchingState;
}({});
const initialCountriesState = {
  countries: [],
  fetchingCountries: false,
  failedOnFetch: false
};

// eslint-disable-next-line default-param-last
export const fetch = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialCountriesState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case GET_PEP_ROLE_COUNTRIES:
      return {
        countries: action.countries,
        fetchingCountries: false,
        failedOnFetch: false
      };
    default:
      return state;
  }
};
const initialPepRolesState = {
  pepRoles: [],
  fetchingState: FetchingState.INITIAL
};
export const fetchPepRoles = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialPepRolesState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case GET_PEP_ROLES:
      return {
        pepRoles: action.roles,
        fetchingState: FetchingState.LOADED
      };
    case FETCHING_PEP_ROLES:
      return {
        pepRoles: [],
        fetchingState: FetchingState.LOADING
      };
    case FAILED_GET_PEP_ROLES:
      return {
        pepRoles: [],
        fetchingState: FetchingState.FAILED
      };
    default:
      return state;
  }
};
const initialRcaRolesState = {
  rcaRoles: [],
  fetchingState: FetchingState.INITIAL
};
export const fetchRcaRoles = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialRcaRolesState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case GET_RCA_ROLES:
      return {
        rcaRoles: action.roles,
        fetchingState: FetchingState.LOADED
      };
    case FETCHING_RCA_ROLES:
      return {
        rcaRoles: [],
        fetchingState: FetchingState.LOADING
      };
    case FAILED_GET_RCA_ROLES:
      return {
        rcaRoles: [],
        fetchingState: FetchingState.FAILED
      };
    default:
      return state;
  }
};
export const doPostPepRca = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    submitted: false,
    error: false
  };
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SUBMITTED_PEP_RCA:
      return {
        error: false,
        submitted: true
      };
    case PEP_RCA_SAVE_ERROR:
      return {
        submitted: false,
        error: true
      };
    default:
      return state;
  }
};
export default combineReducers({
  fetch,
  doPostPepRca,
  fetchPepRoles,
  fetchRcaRoles
});